// news.js
const state = {
  lastOrderMsgTime: null,
  lastSystemMsgTime: null,
  orderUnreadCount: 0,
  systemUnreadCount: 0
}

// getters
const getters = {
  isHasUnreadCount: (state) => {
    return state.orderUnreadCount || state.systemUnreadCount
  }
}

// mutations
const mutations = {
  saveLastOrderMsgTime(state, value) {
    state.lastOrderMsgTime = value
  },
  saveLastSystemMsgTime(state, value) {
    state.lastSystemMsgTime = value
  },
  saveOrderUnread(state, value) {
    state.orderUnreadCount = value
  },
  saveSystemUnread(state, value) {
    state.systemUnreadCount = value
  },
  clearUnreadInfo(state) {
    state.lastOrderMsgTime = null
    state.lastSystemMsgTime = null
    state.orderUnreadCount = 0
    state.systemUnreadCount = 0
  },
}

export default {
  state,
  getters,
  mutations
}
